import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { dragNDropConstants } from '../../Globals/constants';
import { DragSource } from 'react-dnd';
import Radium from 'radium';

class WorkplaceDragable extends Component{
  render()  {
    const { connectDragSource } = this.props;
    return connectDragSource(
      <div style={[styles.dragable]}>
        <img src="/images/Drag_and_Drop.png" alt="dragNDrop" />
      </div>
    );
  }
}


var styles = {
  dragable: {
    height: '40px',
    width: '40px',
    textAlign: 'center',
    lineHeight: '40px',
    position: 'absolute',
    left: '0',
    top: '0',
    zIndex: '1',
    cursor:'pointer',
    transform:' translate3d(0,0,0)'
  }
}

//drag logic
const workplaceSource = {
  beginDrag(props) {
    props.setWorkplaceIsDragging(props.workplace.id)
    return {
      workplace: props.workplace,
      position: props.position,
      shouldPreviewBeSmall: props.shouldPreviewBeSmall
    };
  },
  endDrag(props){
    props.setWorkplaceIsDragging(null)
  }
};

function collect(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging()
  }
}
  WorkplaceDragable.propTypes = {
    workplace: PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      client: PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        contact: PropTypes.shape({
          id: PropTypes.string.isRequired,
          name: PropTypes.string.isRequired
        }).isRequired
      }).isRequired,
      project: PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        number: PropTypes.string.isRequired
      }).isRequired,
      employees: PropTypes.object.isRequired
    }),
    position: PropTypes.shape({
      columnIndex: PropTypes.number.isRequired,
      index: PropTypes.number.isRequired
    }),
    setWorkplaceIsDragging: PropTypes.func.isRequired,
    shouldPreviewBeSmall: PropTypes.bool.isRequired
  };
export default DragSource(dragNDropConstants.WORKPLACE, workplaceSource, collect)(Radium(WorkplaceDragable));


// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Kanban/workplaceDragable.jsx